import { FC, PropsWithChildren, useEffect } from "react";
import { Configure, Index, useInstantSearch } from "react-instantsearch-hooks";
import { InstantSearchStatus } from "instantsearch.js/es/lib/InstantSearch";
import useAlgoliaIndex from "src/hooks/algolia/useAlgoliaIndex";
import { localeFix } from "src/utils/genderLocale/genderLocale";
import contextKeys from "src/utils/algolia/contextKeys";
import useAlgoliaFilters from "src/hooks/algolia/useAlgoliaFilters";
import { SLUG_FACET } from "src/utils/algolia";
import { Gender } from "src/types/Algolia";
import {
  LOGGED_IN_USER,
  NON_LOGGED_IN_USER,
  WEB_SHOP,
} from "src/utils/algolia/analyticsTags";
import { useIsLoggedIn } from "src/hooks/useIsLoggedIn";

interface BrandsIndex extends PropsWithChildren {
  plpType?: number;
  genderId: string;
  brandSlug: string;
  onStatusChanged: (status: InstantSearchStatus) => void;
}

const BrandsIndex: FC<BrandsIndex> = ({
  plpType,
  genderId,
  brandSlug,
  onStatusChanged,
  children,
}) => {
  const isLoggedIn = useIsLoggedIn();
  const localeGenderId = localeFix({ gender: genderId }) as Gender;
  const index = useAlgoliaIndex({
    indexName: "brands",
  });
  const filters = useAlgoliaFilters({
    gender: localeGenderId,
    slug: brandSlug,
    plpType,
  });
  const configurationProps = {
    facets: [SLUG_FACET],
    ruleContexts: [WEB_SHOP, plpType ? contextKeys[plpType] : ""],
    analyticsTags: [
      WEB_SHOP,
      localeFix({ gender: localeGenderId }),
      isLoggedIn ? LOGGED_IN_USER : NON_LOGGED_IN_USER,
    ],
    filters,
  };
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
  const { status } = useInstantSearch();
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    onStatusChanged(status);
  }, [onStatusChanged, status]);

  return (
    <Index indexName={index} indexId={SLUG_FACET}>
      <Configure {...configurationProps} />
      {children}
    </Index>
  );
};

export default BrandsIndex;
